/**
 * @file Renders its children stacked vertically with a standard gap.
 */
import type { ReactNode } from "react";
import { Space } from "antd";

import { W1 } from "@components/Constants";

type Props = {
  children: ReactNode;
};

/**
 * Renders its children in a full-width vertical stack with a standard
 * gap between each one.
 */
const Stack = ({ children }: Props): JSX.Element => {
  return (
    <Space direction="vertical" style={{ width: "100%" }} size={W1}>
      {children}
    </Space>
  );
};

export default Stack;
